import { get, post } from "App/Network/Axios";
import React, { useEffect, useState, useRef } from "react";
import Filter from "retro/Filter";
import { DownloadCsv } from 'retro/Utils';
import DownloadIcon from "@atlaskit/icon/glyph/download";

import {
  Button,
  Empty,
  Loader,
  NavDivider,
  Navigation,
  Pages,
  PaginationCardTableSwitch,
  TableViewSwitch,
  TOAST,
  Form,
  Input,
  SelectInput,
  SidePane,
  Modal,
  Switch
} from "retro/index";
import EffectiveTds from "./EffectiveTds";

function AllTds() {
  const [data, setData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [fileredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Mode, setMode] = useState("list");
  const SECTION = useRef(),
    DESCRIPTION = useRef(),
    EXEMPTION_LIMIT = useRef(),
    THRESHOLD_LIMIT = useRef(),
    INDIVIDUAL_HUF_RATE_LIMIT = useRef(),
    OTHER_LIMIT = useRef(),
    MONTH_REF = useRef(true),
    PIN = useRef()

  const [isSidePaneOpen, setIsSidePaneOpen] = useState(false);
  const [edit, setEdit] = useState(false)
  const [baseExclusive, setBaseExclusive] = useState(true);
  const [view,setView] = useState(false)
  const [pin,setPin] = useState(false);
  const [deleteConfirm,setDeleteConfirm] = useState(false)

  useEffect(()=>{
    if(edit && edit.isForeignTds){
      setChecked(true)
    }
  },[edit])

  const handleSubmit = () => {
    const section = SECTION.current.value;
    const description = DESCRIPTION.current.value;
    const exemption_limit = EXEMPTION_LIMIT.current.value;
    const threshold_limit = THRESHOLD_LIMIT.current.value;
    const individual_huf_rate = INDIVIDUAL_HUF_RATE_LIMIT.current.value;
    const other_limit = OTHER_LIMIT.current.value;

    if (
      !section ||
      !description ||
      !exemption_limit ||
      !individual_huf_rate ||
      !other_limit ||
      !threshold_limit
    ) {
      TOAST.error("Please fill out all required fields.");
      return;
    }
    if(threshold_limit<0){
      TOAST.error("Threshold limit should be greater than 0");
      return;
    }
    if(exemption_limit<0){
      TOAST.error("Exemption limit should be greater than 0");
      return;
    }
    if(individual_huf_rate<0){
      TOAST.error("Individual huf rate should be greater than 0");
      return;
    }
    if(other_limit<0){
      TOAST.error("Other limit should be greater than 0");
      return;
    }
    if(Number(threshold_limit)>Number(exemption_limit)){
      TOAST.error("Threshold limit should be less than exemption limit");
      return; 
    }

    post(
      `/data/tds/addTds`,
      {
        section: section,
        description: description,
        exemption_limit: Number(exemption_limit),
        threshold_limit: Number(threshold_limit),
        individual_huf_rate: Number(individual_huf_rate),
        monthly: baseExclusive === false ? MONTH_REF.current:false,
        base_exclusive: baseExclusive,
        other_rate: Number(other_limit),
        isForeignTds: checked
      },
      (e, r) => {
        if (r) {
          TOAST.success("TDS added successfully");
          setBaseExclusive(true)
          fetchAllTDS();
        } else {
          TOAST.handleError(e);
        }
      }
    );

    setIsSidePaneOpen(false);
  };
  const onSearch = (val) => {
    if (val && val.length > 1) {
      let items = data;
      items = data.filter((item) => {
        return JSON.stringify(item).toLowerCase().includes(val.toLowerCase());
      });
      setFilteredData(items);
    } else {
      setFilteredData(data);
    }
  };

  const fetchAllTDS = () => {
    get("/data/tds/getAllTds", (e, r) => {
      if (r) {
        setData(r.tds);
        setFilteredData(r.tds);
        setLoading(false);
      } else if (e) {
        TOAST.handleError(e);
        return;
      }
    });
  };

  const handleDelete = () => {

    const pin = PIN.current.value;

    if(!pin){
        TOAST.error('Please enter pin');
        return
    }
    post(`data/tds/${deleteId}/deleteTdsRate`,{pin},(e,r)=>{
        if(r){
            TOAST.success('Effective TDS Rate Deleted Successfully')
            loadRates()
            setDeleteConfirm(false)
        }else if (e){
            TOAST.handleError(e)
        }
    }) 
  }

  useEffect(() => {
    fetchAllTDS();
  }, []);

  if (loading) {
    return (
      <Pages.Page>
        <Loader />
      </Pages.Page>
    );
  }

  return (
    <Pages.Page>
      <Navigation
        backUrl={""}
        title={"TDS Master"}
        chips={["All TDS"]}
        description={"All TDS Records"}
      />
      <NavDivider />

      <div className="mb5">
      <Filter
          margin="-2rem -4rem"
          onSearch={(val) => onSearch(val)}
          actions={
            <>
              <Button
                onClick={() => {
                  let fileName = "TdsData.csv";
                  let baseData = [
                    ["Section", "Description", "Other Rate", "Individual HUF Rate", "Exemption Limit", "Monthly"],
                  ];
                  baseData = [
                    ...baseData,
                    ...data.map((item) => [
                      item?.section || "-",
                      item?.description || "-",
                      item?.otherRate || "-",
                      item?.individualHufRate || "-",
                      item?.exemptionLimit || "-",
                      item?.monthly || "-",
                    ]),
                  ];
                  DownloadCsv(fileName, baseData);
                }}
                className="btn btn-paper"
                margin="mr2"
              >
                <DownloadIcon size="small" />
                <span className="ml1">Export</span>
              </Button>
            </>
          }
        >
          <TableViewSwitch size="small" selected={Mode} setSelected={setMode} />
        </Filter>
      </div>
      <div>
        {" "}
        <Button
          style={{ marginBottom: "1rem" }}
          onClick={() => {
            setIsSidePaneOpen(true);
          }}
        >
          + Add TDS
        </Button>
      </div>

      <PaginationCardTableSwitch
        mode={Mode}
        data={fileredData}
        width={150}
        mapCard={(item) => {
          return (
            <div className="retro-card FadeInUp-Effect relative">
              <h3 className="mt1">{item.section}</h3>
              <p className="text-small">
                {`Description:  ${item.description}`}
              </p>
              <p className="text-small">{`Other Rate: ${item.otherRate}`}</p>
              <p className="text-small">
                {`Individual huf rate: ${item.individualHufRate}`}
              </p>
              <p className="text-small">
                {`Exemption limit: ${item.exemptionLimit}`}
              </p>
              <p className="text-small">
                {`Threshold limit: ${item.thresholdLimit}`}
              </p>
              <p className="text-small">
                {`Base Exclusive: ${item.baseExclusive}`}
              </p>
              <p className="text-small">{`Monthly: ${item.monthly}`}</p>
            </div>
          );
        }}
        emptyState={<Empty />}
        loading={loading}
        rows={fileredData.map((item) => {
          return [
            {
              weight: 1,
              children: (
                <p>
                  {item.section}
                  <p>{item.description}</p>
                </p>
              ),
            },
            { weight: 1, title: `${item.otherRate}` || "-" },
            { weight: 1, title: item.individualHufRate || "-" },
            { weight: 1, title: item.exemptionLimit || "-" },
            { weight: 1, title: `${item.thresholdLimit}` || "-" },
            { weight: 1, title: `${item.baseExclusive}` || "-" },
            { weight: 1, title: `${item.monthly}` || "-" },
            { weight: 1, buttons:[{title:'Delete',
              className: 'decline-btn btn-sm',
              onClick:()=>{
                setDeleteConfirm(item);
                post(`data/tds/${item.id}/deleteTdsRate`,{},(e,r)=>{
                  if(r){
                      TOAST.success('Effective TDS Rate Deleted Successfully')
                      loadRates()
                      setDeleteConfirm(false)
                  }else if (e){
                      TOAST.success(e.data.message)
                  }
              })
            },},{title:'Edit', onClick:()=>setEdit(item),className: 'btn-secondary btn-sm'},
            {title:'View', onClick:()=>setView(item.id),className: 'btn-secondary btn-sm'}
          ]},
          ];
        })}
        headers={[
          "Details",
          "Other Rate",
          "Individual huf rate",
          "Exemption limit",
          "Threshold limit",
          "Base Exclusive",
          "Monthly",
          "Actions",
        ].map((item) => ({
          title: item,
          weight: 1,
          
        }))}
      />

      {isSidePaneOpen && (
        <SidePane
          width={400}
          title="Add Tds"
          onClose={() => setIsSidePaneOpen(false)}
          description="Please add the following details to add Tds"
        >
          <Form>
            <>
              <Input
                ref={SECTION}
                type="text"
                label="Section"
                placeholder="Section"
              />
              <Input
                className="mt2"
                ref={DESCRIPTION}
                type="text"
                label="Description"
                placeholder="Description"
              />
              <Input
                className="mt2"
                ref={EXEMPTION_LIMIT}
                type="number"
                label="Exemption limit"
                placeholder="Exemption limit"
              />
               <Input
                className="mt2"
                ref={THRESHOLD_LIMIT}
                type="number"
                label="Threshold limit"
                placeholder="Threshold limit"
              />
              <Input
                className="mt2"
                ref={INDIVIDUAL_HUF_RATE_LIMIT}
                type="number"
                label="Individual huf rate limit"
                placeholder="Individual huf rate limit"
              />
              <Input
                className="mt2"
                ref={OTHER_LIMIT}
                type="number"
                label="Other Limit"
                placeholder="Other Limit"
              />
              <SelectInput
                options={[
                  { value: true, label: "True" },
                  { value: false, label: "False" },
                ]}
                onChange={(val) => setBaseExclusive(val === 'true')}
                type="text"
                label="Base Exclusive"
                className="mt2"
              />
              {baseExclusive === false ?
                <SelectInput
                options={[
                  { value: true, label: "True" },
                  { value: false, label: "False" },
                ]}
                onChange={(val) => (MONTH_REF.current = val === "true")}
                type="text"
                label="Monthly"
                className="mt2"
              />
              :null
              
            }
            <div className="flex justify-between mt4">
              <p className="bold">Foreign Tds</p>
              <Switch state={checked} onChange={(val) => {
                  setChecked(val)
              }} />
            </div>
              <Button
                style={{ width: "100%", marginTop: "1rem" }}
                onClick={() => handleSubmit()}
              >
                ADD TDS
              </Button>
            </>
          </Form>
        </SidePane>
      )}
      {edit &&
        <Modal title="Edit TDS Rates" description="Enter the required rates" onClose={()=>{setEdit(false);setPin(false);setChecked(false)}}
          onSubmit={()=>{
            let individual_huf_rate = INDIVIDUAL_HUF_RATE_LIMIT.current.value;
            let other_limit = OTHER_LIMIT.current.value;
            if (
              !individual_huf_rate ||
              !other_limit
            ) {
              TOAST.error("Please fill out all required fields.");
              return;
            }
            const data = {
              individual_huf_rate: Number(individual_huf_rate),
              other_rate: Number(other_limit),
              isForeignTds: checked,
            }; 
            if(pin){
              data.pin = PIN.current.value
            }

            post(`/data/tds/${edit.id}/editTds`,data,(e, r) => {
                if (r) {
                  TOAST.success("TDS edit successfully");
                  fetchAllTDS();
                  setChecked(false)
                  setEdit(false);
                  setPin(false)
                } else {
                  TOAST.error(e.data.message);

                  setPin(true)
                }
              }
            );
          }}
          button="Update"
        >
          
                <Input
                  className="mt2"
                  ref={INDIVIDUAL_HUF_RATE_LIMIT}
                  defaultValue={edit.individualHufRate}
                  type="number"
                  label="Individual huf rate limit"
                  placeholder="Individual huf rate limit"
                />
                <Input
                  className="mt2"
                  ref={OTHER_LIMIT}
                  defaultValue={edit.otherRate}
                  type="number"
                  label="Other Limit"
                  placeholder="Other Limit"
                />
              <div className="flex justify-between mt4">
                <p className="bold">Foreign Tds</p>
                <Switch state={checked} onChange={(val) => {
                    setChecked(val)
                }} />
              </div>
          
        {pin && <>
            <Input key={"PIN"} label='Pin' placeholder='enter pin sent in mail' ref={PIN}/>
          </>
        }
        </Modal>
      }
      {deleteConfirm && 
          <Modal 
              title='Enter PIN To Delete' 
              description='Are you sure you want to delete this Effective TDS rate?' 
              onClose={()=>setDeleteConfirm(false)} 
              onSubmit={handleDelete}
              button='Delete'
              >
              <Input label='Pin' placeholder='enter pin' ref={PIN} type='password'/>
          </Modal>
      }
      {view && <EffectiveTds onClose={()=>setView(false)} id={view}/>}
    </Pages.Page>
  );
}

export default AllTds;